/* eslint-disable @typescript-eslint/no-explicit-any */
import PullToRefresh from 'react-simple-pull-to-refresh';
import styled from 'styled-components';

interface PullToRefreshProps {
  isPullable?: boolean;
  canFetchMore?: boolean;
  onRefresh: () => Promise<void>;
  onFetchMore?: () => Promise<any>;
  refreshingContent?: JSX.Element | string;
  pullingContent?: JSX.Element | string;
  children: JSX.Element;
  pullDownThreshold?: number;
  fetchMoreThreshold?: number;
  maxPullDownDistance?: number;
  resistance?: number;
  backgroundColor?: string;
  className?: string;
}
const PullToRefreshContainer = ({
  children,
  pullingContent = '',
  ...props
}: PullToRefreshProps) => {
  return (
    <StyledPullToRefresh
      {...props}
      pullingContent={pullingContent}
      maxPullDownDistance={props.maxPullDownDistance ?? 70}
      bottomPadding={props.maxPullDownDistance ?? 70}
    >
      {children}
    </StyledPullToRefresh>
  );
};

export default PullToRefreshContainer;

const StyledPullToRefresh = styled(PullToRefresh)<{ bottomPadding?: number }>`
  ${({ theme, bottomPadding }) => `
    padding-bottom: ${bottomPadding}px;
    .lds-ellipsis {
      width: 60px;
      height: 60px;
    }
    
    .lds-ellipsis div {
      background: ${theme.color.primary500};
      width: 8px;
      height: 8px;
    }

    .ptr__pull-down {
      opacity: 0;
    }
    .ptr__loader {
      display: none;
    }
  `};
`;
